import React from 'react';
import {SolutionTube, GlassTube} from '@learningblocks/storybook-components';
import {Utilities} from '@learningblocks/exp-constants';
import './style.scss';

const {PROTOCOL_LAB_APPARATUS} = Utilities;

export function RenderTubeImage(props) {
  switch (props.type) {
    case PROTOCOL_LAB_APPARATUS.TUBE:
      return <TubeOne {...props} />;
    case PROTOCOL_LAB_APPARATUS.GLASS_TUBE:
      return <TubeTwo {...props} />;
    default:
      return null;
  }
}

function TubeOne(props) {
  return (
    <div className={props.className}>
      <SolutionTube
        size={props.size}
        isOpen={props.isOpen}
        toggleOpen={props.toggleOpen}
        solution={props.solution}
      />
    </div>
  );
}

TubeOne.defaultProps = {
  className: 'tubeImage',
  size: 'md',
  isOpen: false,
  toggleOpen: () => {},
  solution: {label: ' '},
};

function TubeTwo(props) {
  return (
    <div className={props.className}>
      <GlassTube
        boxId={props.boxId}
        snailId={props.snailId}
        plantId={props.plantId}
        stopperId={props.stopperId}
        solution={props.solution}
        tubeLabel={props.tubeLabel}
        onDropItem={props.onDropItem}
        onRemoveItem={props.onRemoveItem}
        setTubeOpen={props.setTubeOpen}
      />
    </div>
  );
}

TubeTwo.defaultProps = {
  className: 'tubeImage',
  stopperId: undefined,
  boxId: undefined,
  snailId: undefined,
  plantId: undefined,
  solution: '#66cef5',
  tubeLabel: ' ',
  onDropItem: () => {},
  onRemoveItem: () => {},
  setTubeOpen: () => {},
};
